var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import Tooltip, { Tip } from "./Tooltip";
import { IconWrapper } from "./styled";
var OccasionIcon = /** @class */ (function (_super) {
    __extends(OccasionIcon, _super);
    function OccasionIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OccasionIcon.prototype.render = function () {
        var _a = this.props, occasion = _a.occasion, formatMessage = _a.formatMessage;
        if (!occasion) {
            return null;
        }
        var occasionLabel = occasion.name;
        var occasionAlt = occasion.icon.alt;
        var occasionHref = occasion.icon.href;
        var occasionName = occasion.default ? React.createElement(FormattedMessage, { id: occasionLabel }) : occasionLabel;
        var occasionImgAlt = occasion.default ? React.createElement(FormattedMessage, { id: occasionAlt }) : occasionAlt;
        return (React.createElement(Tooltip, { placement: "top", tip: React.createElement(Tip, { id: occasionName + "Tooltip" }, occasionName) },
            React.createElement(IconWrapper, { archived: occasion.archived },
                React.createElement("img", { src: occasion.default ? formatMessage({ id: occasionHref }) : occasionHref, alt: occasionImgAlt }))));
    };
    return OccasionIcon;
}(Component));
export default injectIntl(OccasionIcon);
